import { ReactNode, useMemo } from 'react';
import { ColumnsType } from 'antd/es/table';
import { CellTableParagraph } from '@/shared/components/cell-table-paragraph/cell-table-paragraph';
import { Actions } from '@/shared';
import { RubberCatalogResponse } from '@/shared/state/api/swagger';
import styles from '../ui/rubber-product-table.module.scss';

export const useRubberProductColumns = (
	onDelete: (row: RubberCatalogResponse) => void,
	onEdit: (row: RubberCatalogResponse) => void,
	onCreateSimilar: (row: RubberCatalogResponse) => void,
) => {
	const RUBBER_PRODUCT_CATALOG_COLUMNS: ColumnsType<RubberCatalogResponse> = useMemo(() => {
		const onHeaderCell: ColumnsType<RubberCatalogResponse>[number]['onHeaderCell'] = (column) => {
			return {
				style: {
					width: '100%',
					whiteSpace: 'normal',
				},
			};
		};

		return [
			{
				key: 'symbol',
				title: 'Обозначение РТИ',
				dataIndex: 'symbol',
				sorter: true,
				sortDirections: ['ascend', 'descend'],
				className: styles['symbol-table'],
				render: (value: string) => <CellTableParagraph value={value} />,
				onHeaderCell,
				fixed: 'left',
			},
			{
				key: 'name',
				title: 'Наименование РТИ',
				dataIndex: 'name',
				sorter: true,
				sortDirections: ['ascend', 'descend'],
				render: (value: string) => <CellTableParagraph value={value} maxWidth={window.innerWidth / 3} />,
				onHeaderCell,
			},
			{
				key: 'material_symbol',
				title: 'Обозначение материала',
				className: styles['material-symbol'],
				dataIndex: ['material', 'symbol'],
				sorter: true,
				sortDirections: ['ascend', 'descend'],
				render: (value: string) => <CellTableParagraph value={value} />,
				onHeaderCell,
			},
			{
				key: 'material_gost',
				title: <>ТУ&#44; ГОСТ</>,
				className: styles['material-gost'],
				dataIndex: ['material', 'gost'],
				sorter: true,
				sortDirections: ['ascend', 'descend'],
				render: (value: string) => <CellTableParagraph value={value} />,
				onHeaderCell,
			},
			{
				key: 'material_sortament',
				title: 'Сортамент',
				className: styles['material-sortament'],
				dataIndex: ['material', 'sortament'],
				sorter: true,
				sortDirections: ['ascend', 'descend'],
				render: (value: string) => <CellTableParagraph value={value} />,
				onHeaderCell,
			},
			{
				key: 'billet',
				title: 'Заготовка',
				className: styles['standard-consumption'],
				dataIndex: ['billet'],
				sorter: true,
				sortDirections: ['ascend', 'descend'],
				render: (value: string) => <CellTableParagraph value={value} />,
				onHeaderCell,
			},
			{
				key: 'weighed_amount',
				title: 'Навеска, гр',
				className: styles['standard-consumption'],
				dataIndex: ['weighed_amount'],
				sorter: true,
				sortDirections: ['ascend', 'descend'],
				render: (value: string) => <CellTableParagraph value={value} />,
				onHeaderCell,
			},
			{
				key: 'press_form',
				title: 'Пресс-форма для вулканизации',
				className: styles['standard-consumption'],
				dataIndex: ['press_form'],
				sorter: true,
				sortDirections: ['ascend', 'descend'],
				render: (value: string) => <CellTableParagraph value={value} />,
				onHeaderCell,
			},
			{
				key: 'thermostating_mandrel',
				title: 'Оправка для термостатирования',
				className: styles['standard-consumption'],
				dataIndex: ['thermostating_mandrel'],
				sorter: true,
				sortDirections: ['ascend', 'descend'],
				render: (value: string) => <CellTableParagraph value={value} />,
				onHeaderCell,
			},
			{
				key: 'standard_consumption_grams',
				title: <>НР на ед&#44; г</>,
				className: styles['standard-consumption'],
				align: 'left',
				dataIndex: 'standard_consumption_grams',
				sorter: true,
				sortDirections: ['ascend', 'descend'],
				render: (value: number) => (
					<CellTableParagraph value={value ? String(value).replace('.', ',') : '-'} textAlign={'right'} />
				),
				onHeaderCell,
			},
			{
				key: 'actions',
				title: 'Действия',
				className: styles['actions'],
				align: 'left',
				dataIndex: 'actions',
				render: (_: ReactNode, row: RubberCatalogResponse) => {
					return (
						<Actions
							width={120}
							onDelete={() => onDelete(row)}
							onEdit={() => onEdit(row)}
							withTemplate
							onCreate={() => onCreateSimilar(row)}
							tooltip={{
								duplicate: 'Создать похожую деталь',
								edit: 'Редактировать деталь',
								del: 'Удалить деталь',
							}}
						/>
					);
				},
				onHeaderCell,
				fixed: 'right',
			},
		];
	}, [onDelete, onEdit, onCreateSimilar]);

	return RUBBER_PRODUCT_CATALOG_COLUMNS;
};
